/**
 * Validate a post-login `redirect` query value into a safe in-app destination.
 *
 * Returns the path to navigate to, or null when there's no usable redirect (so
 * callers fall back to their default landing). Only root-relative paths are
 * allowed; protocol-relative ("//host") and backslash tricks are rejected so a
 * tampered ?redirect= can never bounce the user off-app. Mirrors the backend
 * guard in MagicLinkController.isSafeInternalRedirect.
 */
export function safeRedirectTarget(redirect) {
	if (
		typeof redirect === "string" &&
		redirect.startsWith("/") &&
		!redirect.startsWith("//") &&
		!redirect.includes("\\")
	) {
		return redirect;
	}
	return null;
}
